import { Button } from '../../components';
import React from 'react';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';
import '../Modal/Modal.global.scss';
import warning from '../../assets/svg/warning.svg';

interface Props {
  handleModalClose: any,
  deleteChannelService: any;
}

const ChannelManagementDelete: React.FC<Props> = (props: Props) => {
  const { handleModalClose, deleteChannelService } = props;
  return (
    <div className="delete_modalContainer">
      <img src={warning} alt="warning" />
      <h2>Delete Channel </h2>
      <p>Are you sure you want to delete this Channel? </p>
      <div className="modalButtonWrapper">
        <Button
          onClick={handleModalClose}
        >
          No
        </Button>
        <Button
          onClick={deleteChannelService}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};
export default ChannelManagementDelete;
